import styled from 'styled-components';

export const NoSuggestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  justify-content: center;
  height: 292px;
  padding: 0px 24px;
`;
